export const LanguageMap = new Map<string, string>([['ro', 'Romanian']]);

export const VoicesMap = new Map<string, string>([
    ['gia', 'Gia'],
    ['ema', 'Ema'],
    ['maria', 'Maria'],
    ['alex', 'Alex'],
    ['radu', 'Radu'],
    ['radu_v23.2', 'Radu v23.2'],
    ['bt_20240201', 'BT-20240201'],
    ['bt_20240509', 'BT-20240509'],
]);
